import {
  Input,
  ControlledCheckbox,
} from "components/UI/ControlledFormElements";
import { useForm } from "react-hook-form";
import style from "./contactForm.module.scss";
import { photoshootType } from "utils/storyCategories";
import clsx from "clsx";
import { Button, FormGroup } from "@mui/material";
import { useEffect } from "react";
import { getAgent } from "utils/getAgent";
import { contactFormInputNamesLS } from "./contactFormInputNames";

export const ContactForm = () => {
  const {
    handleSubmit,
    formState: { errors },
    reset,
    watch,
    clearErrors,
    setValue,
    setError,
    control,
  } = useForm();

  const watchCheckboxes = watch(photoshootType.map((cat) => cat.value)).filter(
    (cat) => cat === true
  );
  const agent = getAgent();

  useEffect(() => {
    contactFormInputNamesLS.getInputNames.forEach((item) => {
      setValue(item, contactFormInputNamesLS.getValueFromLS(item));
    });
  }, []);

  useEffect(() => {
    if (watchCheckboxes.length > 0 && errors.categories) {
      clearErrors("categories");
    }
  }, [watchCheckboxes]);

  const onSubmit = (form) => {
    const selectedCategories = photoshootType.filter((cat) => form[cat.value]);
    if (selectedCategories.length === 0) {
      setError("categories", {
        type: "custom",
        message:
          "Please choose at least one type of service you are interested in.",
      });
      return;
    }
    // code above is for validation of checkboxes
  };
  return (
    <>
      <h1 className={style.header}>I would love to capture</h1>
      <p className={clsx(style.header, style.subheader)}>your special day </p>
      <form onSubmit={handleSubmit(onSubmit)} className={style.form}>
        <Input
          errorText={"Name is required"}
          control={control}
          placeholder="Your name"
          name={contactFormInputNamesLS.inputNames.name}
          label={"Full name"}
        />
        <Input
          errorText={"Email is required"}
          placeholder="youremail@email.com"
          control={control}
          name={contactFormInputNamesLS.inputNames.email}
          label={"Email address"}
          type="email"
        />

        <p className={style.text}>
          What kind of photography/service are you interested in?
        </p>
        <FormGroup>
          {photoshootType.map((cat) => (
            <ControlledCheckbox
              required={false}
              key={cat.value}
              control={control}
              label={cat.label}
              name={cat.value}
            />
          ))}
        </FormGroup>
        <p className={clsx(style.text, style.error)}>
          {errors.categories && errors.categories.message}
        </p>

        <Input
          errorText={"Wedding date is required"}
          control={control}
          name={contactFormInputNamesLS.inputNames.date}
          type="date"
          label={agent === "Mobile" ? "Chose your date" : ""}
        />
        <Input
          errorText={"Ceremony/wedding location is required"}
          control={control}
          placeholder="Please share the details of your wedding location"
          name={contactFormInputNamesLS.inputNames.location}
          label={"What is your ceremony/wedding location?"}
          multiline
        />
        <Input
          control={control}
          placeholder="What's your budget?"
          name={contactFormInputNamesLS.inputNames.budget}
          label={"Approximate budget"}
        />

        <Input
          errorText={"Your message is required"}
          control={control}
          placeholder="Please share your wedding day/photoshoot details with me"
          name={contactFormInputNamesLS.inputNames.message}
          label={"Your message"}
          multiline
          required={false}
        />
        <Input
          control={control}
          placeholder="Are you interested in any additional services?"
          name={contactFormInputNamesLS.inputNames.services}
          label={"Additional services"}
          multiline
        />

        <Button
          variant="contained"
          sx={{ marginRight: 2 }}
          color="warning"
          type="submit"
        >
          Submit
        </Button>
      </form>
    </>
  );
};
